import React from "react";
import { Card, Col, Row } from "antd";
import { useSelector } from "react-redux";
import TotalCompanies from "../../../../../assets/images/total-companies.png";
import MyCompanies from "../../../../../assets/images/my-companies.png";
import SharedCompanies from "../../../../../assets/images/shared-companies.png";

function Analytics() {
  const companies = useSelector((state) => state.CompanyReducer.companies);
  const myCompanies = companies.filter((company) => company.created_by_user);
  const sharedCompanies = companies.filter(
    (company) => !company.created_by_user
  );
  return (
    <>
      <Row gutter={[18, 18]}>
        <Col xs={24} lg={8}>
          <Card className="analytics-card">
            <div className="thumbnail">
              <img src={TotalCompanies} alt="" />
            </div>
            <div className="detail">
              <h3>Total Companies</h3>
              <h1>{companies.length}</h1>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card className="analytics-card">
            <div className="thumbnail">
              <img src={MyCompanies} alt="" />
            </div>
            <div className="detail">
              <h3>My Companies</h3>
              <h1>{myCompanies?.length}</h1>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card className="analytics-card">
            <div className="thumbnail">
              <img src={SharedCompanies} style={{ width: 35 }} alt="" />
            </div>
            <div className="detail">
              <h3>Shared Companies</h3>
              <h1>{sharedCompanies?.length}</h1>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Analytics;
